// services/enrollmentService.js
import { getAll, getById, create, update, remove, customFetch } from './baseService';

const endpoint = 'enrollments';

const enrollmentService = {
  // Lấy danh sách tất cả enrollments
  getAllEnrollments: async (params) => {
    return getAll(endpoint, params);
  },

  // Lấy thông tin enrollment theo ID
  getEnrollmentById: async (id) => {
    return getById(endpoint, id);
  },

   // Lấy thông tin enrollment theo ID
   getMyEnrollments: async () => {
    return getAll(`${endpoint}/getMe`);
  },

  // Tạo enrollment mới
  createEnrollment: async (enrollmentData) => {
    return create(endpoint, enrollmentData);
  },

  // Cập nhật enrollment theo ID
  updateEnrollment: async (id, enrollmentData) => {
    return update(endpoint, id, enrollmentData);
  },

  // Xóa enrollment theo ID
  deleteEnrollment: async (id) => {
    return remove(endpoint, id);
  },

  // Lấy tổng số lượt đăng ký của course
  getEnrollmentByCourseId: async (id) => {
    return getById(`${endpoint}/course`,id)
  },
};

export default enrollmentService;
